import { render, staticRenderFns } from "./EmployeeDetailsCardReactivationForm.vue?vue&type=template&id=0eabc115&scoped=true&"
import script from "./EmployeeDetailsCardReactivationForm.vue?vue&type=script&lang=ts&"
export * from "./EmployeeDetailsCardReactivationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eabc115",
  null
  
)

export default component.exports